import React from 'react'
import image201 from "../Gallery/201.jpeg"
import image202 from "../Gallery/202.jpeg"
import image203 from "../Gallery/203.jpeg"
import image204 from "../Gallery/204.jpeg"
import image205 from "../Gallery/205.jpeg"
import image206 from "../Gallery/206.jpeg"
import image207 from "../Gallery/207.jpeg"
import image208 from "../Gallery/208.jpeg"
import image209 from "../Gallery/209.jpeg"
import image20b from "../Gallery/201b.jpeg"

import "./gallery.css"
export default function Gallery() {
  return (
   <>
   <footerdd class="footerdd">
            <div class="bd-best">
                <div class="bd-best-list">
                   <figure class="bd-best-item" >
                 <img src={image201} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
              <img src={image202} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                   <img src={image203} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure> 
                  <figure class="bd-best-item">
                   <img src={image204} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                   <img src={image205} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                  <img src={image206} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                   <img src={image207} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item" >
                 <img src={image208} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
              <img src={image209} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                   <img src={image20b} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                   <img src={image201} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                   <img src={image209} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                  <img src={image208} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                   <img src={image205} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item" >
                 <img src={image206} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
              <img src={image205} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                  <figure class="bd-best-item">
                   <img src={image208} calss="bd-best-itemimg" width={200} height={200}/>
                  </figure>
                 
                 
                           
                </div>
           </div>
        </footerdd>
   </>
  )
}
